var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLoader(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.9,
    d: "M267.093,0.008c-33.717,0-61.061,27.327-61.061,61.014c0,33.686,27.342,61.013,61.061,61.013   c33.748,0,61.073-27.327,61.073-61.013C328.184,27.335,300.841,0.008,267.093,0.008z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M117.085,67.788c-30.655,0-55.513,24.828-55.513,55.467c0,30.624,24.858,55.451,55.513,55.451   c30.67,0,55.513-24.827,55.513-55.451C172.597,92.615,147.755,67.788,117.085,67.788z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M104.914,273.107c0-27.546-22.374-49.92-49.966-49.92c-27.592,0-49.966,22.374-49.966,49.92   c0,27.576,22.374,49.92,49.966,49.92C82.54,323.027,104.914,300.686,104.914,273.107z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M85.68,391.619c-17.343,17.313-17.343,45.404,0,62.73c17.358,17.326,45.482,17.326,62.825,0   c17.343-17.326,17.343-45.42,0-62.73C131.162,374.275,103.039,374.275,85.68,391.619z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M267.093,434.336c-21.452,0-38.842,17.375-38.842,38.842c0,21.422,17.391,38.814,38.842,38.814   c21.468,0,38.873-17.393,38.873-38.814C305.966,451.711,288.561,434.336,267.093,434.336z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M393.556,399.447c-12.999,12.982-12.999,34.061,0,47.061c13.016,13,34.092,13,47.123,0c12.999-13,12.999-34.076,0-47.061   C427.647,386.447,406.571,386.447,393.556,399.447z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M479.239,245.375c-15.327,0-27.749,12.405-27.749,27.733s12.422,27.732,27.749,27.732   c15.343,0,27.779-12.404,27.779-27.732S494.582,245.375,479.239,245.375z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M419.242,143.3c12.28,0,22.218-9.922,22.218-22.187c0-12.25-9.938-22.188-22.218-22.171   c-12.249,0-22.218,9.921-22.202,22.171C397.04,133.378,406.993,143.3,419.242,143.3z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoader);
export default __webpack_public_path__ + "static/media/loader.1ff03db3.svg";
export { ForwardRef as ReactComponent };